<template>
  <layout>
    <div slot="content" class="home">
      <div class="visible-lg-block visible-md-block">
        <div class="img_box">
          <!-- <img src="../assets/home/sy_banner.png" alt /> -->
          <div class="img_box_text">
            <h1 class="hidden-xs">货保保 · 做生意更简单、更安全</h1>
            <h3 class="hidden-xs">让工作是工作，生活即生活</h3>

            <h3 class="visible-xs">货保保 · 做生意更简单、更安全</h3>
            <h4 class="visible-xs">让工作是工作，生活即生活</h4>
          </div>
        </div>
      </div>

      <div class="visible-sm-block visible-xs-block">
        <div class="img1_box">
          <!-- <img1 src="../assets/home/sy_banner.png" alt /> -->
          <div class="img1_box_text">
            <h1 class="hidden-xs">货保保 · 做生意更简单、更安全</h1>
            <h3 class="hidden-xs">让工作是工作，生活即生活</h3>

            <h3 class="visible-xs">货保保 · 做生意更简单、更安全</h3>
            <h4 class="visible-xs">让工作是工作，生活即生活</h4>
          </div>
        </div>
      </div>
      <div class="count" ref="count">
        <div class="count_box">
          <!-- lg / md -->
          <div class="visible-lg visible-md">
            <div class="count_box_top">
              <h1>制造业领先品牌的共同选择</h1>
              <!-- <h2>为您带来最佳的经营效果</h2> -->
              <h2>为您带来增值的经营效果</h2>
            </div>
          </div>
          <!-- sm / xs -->
          <div class="visible-sm visible-xs">
            <div class="count_box_xs-top">
              <h1>制造业领先品牌的共同选择</h1>
              <!-- <h2>为您带来最佳的经营效果</h2> -->
              <h2>为您带来增值的经营效果</h2>
            </div>
          </div>

          <!-- lg / md-->
          <div class="count_box_bottom hidden-xs hidden-sm col-lg-12 col-md-8 col-sm-10">
            <div class="count_box_bottom_items">
              <div class="count_box_bottom_items_title1">
                <span id="count_box_bottom_items_title1_1">0</span>
              </div>
              <div class="count_box_bottom_items_text">业内合作商数</div>
            </div>

            <div class="count_box_bottom_items">
              <div class="count_box_bottom_items_title2">
                <span id="count_box_bottom_items_title2_2">0</span>
              </div>
              <div class="count_box_bottom_items_text">促进交易次数</div>
            </div>

            <div class="count_box_bottom_items">
              <div class="count_box_bottom_items_title3">
                <span id="count_box_bottom_items_title3_3">0</span>
              </div>
              <div class="count_box_bottom_items_text">提高管理效率</div>
            </div>

            <div class="count_box_bottom_items">
              <div class="count_box_bottom_items_title4">
                <span id="count_box_bottom_items_title4_4">0</span>
              </div>
              <div class="count_box_bottom_items_text">操作快速上手</div>
            </div>
          </div>

          <!-- sm,xs -->
          <div class="visible-xs-block visible-sm col-xs-12 col-sm-12">
            <div class="count_box_bottom1">
              <div class="count_box_bottom1_xs">
                <div class="count_box_bottom1_xs_title1">
                  <span id="count_box_bottom1_xs_title1_1">0</span>
                </div>
                <div class="count_box_bottom1_xs_text">业内合作商数</div>
              </div>

              <div class="count_box_bottom1_xs">
                <div class="count_box_bottom1_xs_title2">
                  <span id="count_box_bottom1_xs_title2_2">0</span>
                </div>
                <div class="count_box_bottom1_xs_text">促进交易次数</div>
              </div>

              <div class="count_box_bottom1_xs">
                <div class="count_box_bottom1_xs_title3">
                  <span id="count_box_bottom1_xs_title3_3">0</span>
                </div>
                <div class="count_box_bottom1_xs_text">提高管理效率</div>
              </div>

              <div class="count_box_bottom1_xs">
                <div class="count_box_bottom1_xs_title4">
                  <span id="count_box_bottom1_xs_title4_4">0</span>
                </div>
                <div class="count_box_bottom1_xs_text">操作快速上手</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--lg / md / sm  -->
      <div class="introduce hidden-xs">
        <h1 class="introduce_title">货保保 · 做生意更简单、更安全</h1>
        <div class="introduce_content">
          <div class="introduce_content_left">
            <div
              class="introduce_content_left_items"
              v-for="(item,index) in introduceData"
              :key="index"
            >
              <div class="introduce_content_left_items_img">
                <svg :class="item.icon +' icon'" aria-hidden="true">
                  <use :href="`#${item.icon}`" />
                </svg>
              </div>
              <div class="introduce_content_left_items_text">
                <div class="introduce_content_left_items_text_title">{{item.title}}</div>
                <div class="introduce_content_left_items_text_minor">{{item.text}}</div>
              </div>
            </div>
            <div>
              <button class="introduce_content_left_button">了解详情 ></button>
            </div>
          </div>
          <div class="introduce_content_right">
            <img src="../assets/home/sy_img1.png" alt />
          </div>
        </div>
      </div>

      <!--  sm / xs -->
      <div class="introduce1 visible-xs-block">
        <div class="introduce1_xs">
          <h1 class="introduce1_xs_title">货保保 · 做生意更简单、更安全</h1>
          <div class="introduce1_xs_content">
            <div class="introduce1_xs_content_left">
              <div
                class="introduce1_xs_content_left_items"
                v-for="(item,index) in introduceData"
                :key="index"
              >
                <div class="introduce1_xs_content_left_items_img">
                  <svg :class="item.icon +' icon'" aria-hidden="true">
                    <use :href="`#${item.icon}`" />
                  </svg>
                </div>
                <div class="introduce1_xs_content_left_items_text">
                  <div class="introduce1_xs_content_left_items_text_title">{{item.title}}</div>
                  <div class="introduce1_xs_content_left_items_text_minor">{{item.text}}</div>
                </div>
              </div>
            </div>
            <div class="introduce1_xs_content_right">
              <img src="../assets/home/sy_img1.png" alt />
            </div>
          </div>
        </div>
      </div>

      <!-- lg / md / sm  -->
      <div class="page4 hidden-xs">
        <h1>多端协同，一键链接</h1>
        <h3>APP：一键快捷下单； PC 端：协同办公更高效； ERP 提供精准经营数据</h3>
        <div>
          <img src="@/assets/home/sy_img2.png" alt />
        </div>
      </div>

      <!--  xs -->
      <div class="page41 visible-xs">
        <div class="page41_xs">
          <h1>多端协同，一键链接</h1>
          <h3>APP：一键快捷下单； PC 端：协同办公更高效； ERP 提供精准经营数据</h3>
          <div>
            <img src="@/assets/home/sy_img2.png" alt />
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script src="../utils/count.js"></script>
<script>
import layout from "../components/layout/Index";
import { CountUp } from "countup.js";
export default {
  components: {
    layout,
  },
  data() {
    return {
      introduceData: [
        {
          icon: "icon-gzt",
          title: "数据监控",
          text: "智能数据看板,实时监控经营效果",
        },
        {
          icon: "icon-12",
          title: "工作台",
          text: "一键完成财务/销售/采购/仓库以及物流工作",
        },
        {
          icon: "icon-xxgl",
          title: "消息管理",
          text: "内外消息实时沟通,一键发起交易",
        },
        {
          icon: "icon-dianzihetong2",
          title: "交易辅助",
          text: "线上交易合同管理,多种结算方式选择",
        },
        {
          icon: "icon-zbk",
          title: "质保追溯系统",
          text: "电子质保卡,扫码即可溯源商品质保",
        },
      ],
      countEventShow: 0,
    };
  },
  mounted() {
    document.addEventListener("scroll", this.countEvent);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.countEvent);
  },
  methods: {
    countEvent() {
      if (window.scrollY > this.$refs["count"].offsetTop / 2) {
        this.counts();
        this.counts1();
        document.removeEventListener("scroll", this.countEvent);
      }
    },
    counts() {
      new CountUp("count_box_bottom_items_title1_1", 0, {
        useEasing: true,
        useGrouping: true,
      }).start();

      // const countup = new CountUp(title2);
      new CountUp("count_box_bottom_items_title2_2", 0, {
        useEasing: true,
        useGrouping: true,
        decimal: ".",
        decimalPlaces: 1,
        duration: 5,
      }).start();

      new CountUp("count_box_bottom_items_title3_3", 110, {
        useEasing: true,
        useGrouping: true,
        // decimal: ".",
        // decimalPlaces: 1,
      }).start();

      new CountUp("count_box_bottom_items_title4_4", 0.5, {
        useEasing: true,
        useGrouping: true,
        decimal: ".",
        decimalPlaces: 1,
        duration: 5,
      }).start();
    },

    counts1() {
      // 80
      new CountUp("count_box_bottom1_xs_title1_1", 0, {
        useEasing: true,
        useGrouping: true,
      }).start();

      // const countup = new CountUp(title2); 1.4
      new CountUp("count_box_bottom1_xs_title2_2", 0, {
        useEasing: true,
        useGrouping: true,
        decimal: ".",
        decimalPlaces: 1,
        duration: 3,
      }).start();

      new CountUp("count_box_bottom1_xs_title3_3", 110, {
        useEasing: true,
        useGrouping: true,
        // decimal: ".",
        // decimalPlaces: 1,
      }).start();

      new CountUp("count_box_bottom1_xs_title4_4", 0.5, {
        useEasing: true,
        useGrouping: true,
        decimal: ".",
        decimalPlaces: 1,
        duration: 5,
      }).start();
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  // margin-top: viewSize(88);
  width: viewSize(1300);
  // margin: auto;
  .img_box {
    background: url(../assets/home/sy_banner.png) no-repeat;
    background-size: 100% 100%;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    &_text {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      text-align: center;
      color: #fff;
      h1 {
        margin-bottom: viewSize(70);
      }
    }

    img {
      height: 100%;
    }
    // background: url(../assets/home/sy_banner.png) no-repeat 0 0;
  }

  .img1_box {
    background: url(../assets/home/mobile_home.png) no-repeat;
    background-size: 100% 100%;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    &_text {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      text-align: center;
      color: #fff;
    }

    img {
      height: 100%;
    }
    // background: url(../assets/home/sy_banner.png) no-repeat 0 0;
  }

  .count {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    &_box {
      background: url(../assets/home/sy_dt.png) no-repeat;
      // padding: 30px;
      // background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      // 二页 大标题 lg md
      &_top {
        text-align: center;
        font-weight: 700;
        h1 {
          font-size: 48px;
          font-weight: 700;
          margin-bottom: 34px;
        }
        h2 {
          font-size: 34px;
        }
      }
      //  二页 大标题  xs sm
      &_xs-top {
        text-align: center;
        h1 {
          font-size: 22px;
          font-weight: 700;
          margin-bottom: 34px;
        }
        h2 {
          font-size: 16px;
        }
      }

      //  统计数据  lg md 样式
      &_bottom {
        margin-top: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        z-index: 0;
        &_items {
          z-index: 0;
          display: flex;
          box-sizing: border-box;
          flex-direction: column;
          align-content: center;
          justify-content: center;
          width: 260px;
          height: 140px;
          text-align: center;
          box-shadow: 0px 0px 9px 5px #eee;
          background: #fff;
          margin: 10px 10px;
          &_title1 {
            color: $primary_color;
            font-weight: 700;
            font-size: 60px;

            &::after {
              // content: "万";
              padding-left: 5px;
              font-size: 30%;
            }
          }

          &_title2 {
            color: $primary_color;
            font-weight: 700;
            font-size: 60px;

            &::after {
              // content: "亿";
              padding-left: 5px;
              font-size: 30%;
            }
          }

          &_title3 {
            color: $primary_color;
            font-weight: 700;
            font-size: 60px;

            &::after {
              content: "%";
              padding-left: 5px;
              font-size: 30%;
            }
          }

          &_title4 {
            color: $primary_color;
            font-weight: 700;
            font-size: 60px;

            &::after {
              content: "小时";
              padding-left: 5px;
              font-size: 30%;
            }
          }

          &_text {
          }
        }
      }
      //  统计数据  xs sm 样式
      &_bottom1 {
        margin-top: viewSize(100);
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        &_xs {
          display: flex;
          box-sizing: border-box;
          flex-direction: column;
          align-content: center;
          justify-content: center;
          width: 150px;
          height: 100px;
          text-align: center;
          box-shadow: 0px 0px 9px 5px #eee;
          background: #fff;
          padding: viewSize(20);
          margin: viewSize(30);
          z-index: 0;

          &_title1 {
            color: $primary_color;
            font-weight: 700;
            font-size: 36px;
            // font-size: viewSize(40);

            &::after {
              // content: "万";
              padding-left: 5px;
              font-size: 30%;
            }
          }

          &_title2 {
            color: $primary_color;
            font-weight: 700;
            font-size: 36px;

            &::after {
              // content: "亿";
              padding-left: 5px;
              font-size: 30%;
            }
          }

          &_title3 {
            color: $primary_color;
            font-weight: 700;
            font-size: 36px;

            &::after {
              content: "%";
              padding-left: 5px;
              font-size: 30%;
            }
          }

          &_title4 {
            color: $primary_color;
            font-weight: 700;
            font-size: 36px;

            &::after {
              content: "小时";
              padding-left: 5px;
              font-size: 30%;
            }
          }

          &_text {
            margin-top: 8px;
            font-size: 14px;
            color: #666666;
          }
        }
      }
    }
  }

  // lg md
  .introduce {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    background: #fff;
    &_title {
      font-weight: 700;
      margin-bottom: 100px;
      font-size: viewSize(50);
    }
    &_content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 65%;

      &_left {
        &_items {
          display: flex;
          align-items: center;
          margin-bottom: 26px;
          &_img {
            font-size: viewSize(35);
            margin-right: viewSize(31);
          }

          &_text {
            &_title {
              font-size: viewSize(20);
              font-weight: 700;
              margin-bottom: 16px;
            }
            &_minor {
              font-size: 15px;
              color: #8d8d99;
            }
          }
        }
        &_button {
          width: 180px;
          height: 48px;
          border: 0;
          outline: none;
          background: $primary_color;
          font-size: 16px;
          color: #fff;
          &:hover {
            transition: all 1s;
            background: $minor_color;
          }
        }
      }
      &_right {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left:70px;
        img {
          // width: 260px;
          width: 100%;
        }
      }
    }
  }
  //sm xs
  .introduce1 {
    &_xs {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100vw;
      &_title {
        font-weight: 700;
        margin-bottom: 40px;
        font-size: 22px;
      }
      &_content {
        display: flex;
        align-items: center;
        flex-direction: column;
        // justify-content: space-between;
        width: 100%;

        &_left {
          &_items {
            display: flex;
            align-items: center;
            margin-bottom: 26px;
            &_img {
              font-size: 25px;
              margin-right: 15px;
            }

            &_text {
              &_title {
                font-size: 16px;
                font-weight: 700;
                margin-bottom: 12px;
              }
              &_minor {
                font-size: 14px;
                color: #8d8d99;
              }
            }
          }
        }
        &_right {
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 260px;
          }
        }
      }
    }
  }

  .page4 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    h1 {
      font-size: viewSize(48);
      font-weight: 700;
      margin-bottom: viewSize(38);
    }
    h3 {
      font-size: viewSize(20);
      margin-bottom: viewSize(72);
    }
    div {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 85%;
      }
    }
  }

  .page41 {
    .page41_xs {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      width: 100vw;
      height: 100vh;
      h1 {
        font-size: 22px;
        font-weight: 700;
        margin-bottom: 18px;
      }
      h3 {
        font-size: 14px;
        margin-bottom: 36px;
        width: 80%;
      }
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 85%;
        }
      }
    }
  }
}
</style>